<script>
// import { ref, watch } from "vue";
// import useVuelidate from "@vuelidate/core";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
// import DropZone from "@/components/widgets/dropZone";
import axios from 'axios';
import Swal from "sweetalert2";

export default {

    data() {
        return {
            title: "Create Order",
            items: [
                {
                    text: "Order",
                    href: "/",
                },
                {
                    text: "Create",
                    active: true,
                },
            ],
            orderlist: [],
            messageBag: null,
            pageLists: [],
            summary: [],
            selectedDevices: [],
            DevicesUpload: [],
            DetailOrder:[],

            openmodal: false,

            Imgseen:true,
            uploaddeviceSeen: false,
            uploadFileSeen: false,
            deleteclick: true,
            uploadYes:true,
            getUploadDevicesSeen: false,
            isPreviousUpload :false,

            dropzoneOptions: {
                maxFiles: 1,
                acceptedFiles: ".csv"

            },
            uploaded_file:'',
            PhoneSupport:'',

            //calculation
            totalPriceDevices:0,
            messageBagTotalPrice:0,

            orderID_: null,
            //end of calculation

            //loading
            isLoadingListDevices: false,
            isLoadingDetailOrder: false,
            isLoadingCalculateAllPrice:false,

            ErrorUploadYes:false,
            DiplayGrading:false,
            //end of loading

            ButtonSeen: true,
            LoadingUploadSeen: false,
            showExcel: true,

            staticURLDownload: process.env.VUE_APP_API_BASEURL.replace('/api',''),

            url_link:'',
            img_location: require("@/assets/images/EDM2.jpg"),
            mycountry:'MY',
        };
    },
    page: {
        title: "Order",
        meta: [{ name: "Create Order", content: appConfig.description }],
    },

  

  mounted() {
        this.supportNumber();
        this.userConfigure();
		this.myProfile();
        this.clearSession();
        // this.getUploadDevices('93');
	},

  methods: {
    clearSession(){
        const posting_ = { status: "5" };
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'order/reupload/'+localStorage.getItem('orderId_priceCheck'), posting_)
        },
        //api to server
        getList() {
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'order/my')
			.then(response => {

				if (response) {
                    // console.log(response);
                    this.orderlist = response.data;
                } else {
                    this.messageBag = ['No record.'];
                }
			})
                .catch(error => {
                    this.messageBag = [error.error];
			});
		},
        

        submitFile() {
            
            if(this.Images){
                this.LoadingUploadSeen=true; //yak
                this.ButtonSeen=true;
                this.uploadYes=false;
                this.orderID_=null;
                const formData = new FormData();
                formData.append('uploaded_file', this.Images);


                const headers = { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin':'*' };
                axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'order/crete', formData, 
                    { headers }
                ).then((res) => {
                        this.DevicesUpload ='';
                        // console.log(res.data);
                        // console.log(res.data.id);

                        if(res.data.status=='error'){
                            this.messageBag = res.data.msj;
                            this.isLoadingListDevices = false;
                            this.getUploadDevicesSeen = false;
                            this.uploadYes=true;
                        }else{
                            this.messageBag=null;
                            this.getUploadDevices(res.data.id);
                            
                        }
                        this.LoadingUploadSeen=false;
                    }
                );
            }else{
                alert('Please upload template file.');
            }
        },

        getUploadDevices(OrderID){
            this.Imgseen=false;
            this.orderId_=OrderID;//temporary
            
            this.isLoadingListDevices = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'device/'+OrderID)
            
			.then(response => {

				if (response) {
                    if(response.data.status=='error'){
                        this.messageBag = response.data.msj;
                        this.isLoadingListDevices = false;
                        this.getUploadDevicesSeen = false;
                    }else{
                        this.DevicesUpload = response.data;
                        this.isLoadingListDevices = false;
                        this.$refs.clickingstep.click();
                        this.getUploadDevicesSeen = true;
                        this.GetTotalPriceDevices(OrderID);

                        this.GetDetailOrder(this.orderId_);

                        this.ShowErrorUpload(OrderID);

                        setTimeout(window.scrollTo(0, document.body.scrollHeight),4000);
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.isLoadingListDevices = false;
                    this.getUploadDevicesSeen = false;
                }
			})
                .catch(error => {
                    this.messageBag = [error.error];
                    this.isLoadingListDevices = false;
                    this.getUploadDevicesSeen = false;
			});
            
        },

        ShowErrorUpload(OrderID){
            this.ErrorUploadYes = false;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'device/error/'+OrderID)
            
			.then(response => {
                if(response.data.line !='0'){
                    this.ErrorUploadYes = true;
                    this.ErrorUpload = response.data;
                    console.log(this.ErrorUpload);
                }
            });
        },

        GetDetailOrder(OrderID){

            this.isLoadingDetailOrder = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'order/'+OrderID)
            
			.then(response => {

				if (response) {
                    if(response.data.status=='error'){
                        this.messageBag = response.data.msj;
                        this.isLoadingDetailOrder = false;
                    }else{
                        this.DetailOrder = response.data['0'];
                        console.log(this.DetailOrder);
                        this.isLoadingDetailOrder = false;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.isLoadingDetailOrder = false;
                }
			})
                .catch(error => {
                    this.messageBag = [error.error];
                    this.isLoadingDetailOrder = false;
			});

        },

        GetTotalPriceDevices(orderId){
            this.isLoadingCalculateAllPrice=true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'device/price/'+orderId)
			.then(response => {

				if (response) {
                    this.orderID_=orderId;
                    // console.log(response.data);
                    this.totalPriceDevices = response.data;
                    this.isLoadingCalculateAllPrice=false;
                } else {
                    this.messageBagTotalPrice = 'Cant Calculate';
                    this.isLoadingCalculateAllPrice=false;
                }
			})
                .catch(error => {
                    this.messageBagTotalPrice = error.error;
                    this.isLoadingCalculateAllPrice=false;
			});
        },

        getPreviousUpload(){
            this.isPreviousUpload = false;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'order/upload')
			.then(response => {

				if (response) {
                    if (typeof response.data.id !== 'undefined') {
                        this.isPreviousUpload = true;
                        this.getUploadDevices(response.data.id);
                        
                    }
                } else {
                    this.messageBagTotalPrice = 'Cant Retreve Id';
                    this.isLoadingCalculateAllPrice=false;
                }
			})
                .catch(error => {
                    this.messageBagTotalPrice = error.error;
                    this.isLoadingCalculateAllPrice=false;
			});
        },
        
        //end of api to server

        viewsummary(devices){
            this.openmodal = true;
            this.summary= devices;
            // console.log(this.summary);
        },
        
        changeLocation(e) {
            if(e.target.value == 1){
                this.uploaddeviceSeen = false;
                this.showAlertApps();
            }else if(e.target.value == "more"){
                this.uploaddeviceSeen = true;
            }else if(e.target.value == "1000"){
                this.showAlertThousand();
            }else{
                this.uploaddeviceSeen = false;
            }
        },
        deleteRecord(ele) {
            this.deleteclick=true;
            ele.target.parentElement.parentElement.remove();
        },

        //popup
        showAlertApps() {
            Swal.fire({
                // title: "",
                imageUrl: require("@/assets/images/qr.png"),
                html:
                "For less than 6 devices, please scan the above QR code to download our InstaCash app in Playstore(for Android) or App Store (for iOS)",
                // showCancelButton: true,
                confirmButtonClass: "btn btn-success me-2",
                cancelButtonClass: "btn btn-danger",
                buttonsStyling: false,
                confirmButtonText:
                'OK',
            });
        },
        showAlertThousand(){
            Swal.fire({
                // title: "<i>HTML</i>",
                icon: "info",
                html:
                "For more than 1,000 devices at one go, please contact our customer service centre at <br> " + this.PhoneSupport,
                // showCancelButton: true,
                confirmButtonClass: "btn btn-success me-2",
                cancelButtonClass: "btn btn-danger",
                buttonsStyling: false,
                confirmButtonText:
                'OK',
            });
        },

        uploadFile() {
            // console.log(this.$refs.file.files[0]);
            this.Images = this.$refs.file.files[0];
        },

        
        rejectButton() {
            Swal.fire({
                title: "Are you sure you want to reject this order?",
                // text: "You won't be able to revert!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                confirmButtonText: "Yes, Reject Order!",
            }).then((result) => {
                if (result.value) {
                    const posting_ = { status: "9" };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/status/'+this.orderId_, posting_)
                    .then(response => {
                        if (response) {
                            Swal.fire("Rejected!", "Your Order has been Rejected.", "success");
                        }else{
                            Swal.fire("Fail!", "Your Order Fail To Rejected. Please try again", "fail");
                        }
                    });
                    this.ButtonSeen=false;
                }
            });
        },

        reupload(){
            this.uploadYes=true;
            Swal.fire({
                title: "Are you sure you want to clear this order?",
                // text: "You won't be able to revert!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                confirmButtonText: "Yes, Clear Order!",
            }).then((result) => {
                if (result.value) {
                    const posting_ = { status: "5" };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/reupload/'+this.orderId_, posting_)
                    .then(response => {
                        if (response) {
                            this.Imgseen=true;
                            this.getUploadDevicesSeen=false,
                            this.isPreviousUpload = false;
                            Swal.fire("Order Cleared!", "Your order data has been deleted.", "success");
                        }else{
                            Swal.fire("Fail!", "Your order data fail to be deleted. Please try again later", "fail");
                        }
                    });
                    this.ButtonSeen=false;
                }
            });
        },

        ApproveButton() {
            Swal.fire({
                title: "Are you sure you want to submit this order?",
                // text: "You won't be able to revert!",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, Submit Order",
            }).then((result) => {
                if (result.value) {

                    const posting_ = { status: "1" };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'order/status/'+this.orderId_, posting_)
                    .then(response => {
                        if (response) {
                            Swal.fire({
                                title:"Order Confirmed!", 
                                html: "Our customer service will contact you soon.", 
                                icon:"success",
                            }).then(() => {
                                this.$router.push('/order/cq/'+this.orderId_); 
                            });
                        }else{
                            Swal.fire("Fail!", "Your Order Fail To Rejected. Please try again", "fail");
                        }
                    });
                    this.ButtonSeen=false;
                }
            });
        },
        userConfigure(){
            this.showExcel = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'user/configure')
            .then(responseConfig => {
                // this.PhoneSupport = responseConfig.data;
                if(responseConfig.data.using_excel=='1'){
                    this.showExcel = false;
                }
            });
        },

        supportNumber(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'country/mycountry')
            .then(response_phone => {
                this.PhoneSupport = response_phone.data.support_number;
                this.mycountry = response_phone.data.code;
                // console.log(this.PhoneSupport);
            });
        },

        myProfile(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'user/my')
            .then(response => {
                if (response) {
                    this.for_company = response.data.for_company;

                    if(this.for_company == 'Apple'){
                        this.url_link = this.staticURLDownload+'storage/template/ModelListGradingGuideline.xlsx';
                    }else{
                        this.url_link = this.staticURLDownload+'storage/template/ModelListGradingGuidelineNormal.xlsx';
                    }

                } else {

                    this.messageBag = ['No record.'];
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },

        DisplayExcelGrading(){
            this.DiplayGrading=true;
            this.getPreviousUpload();
        }
        //end of popup
        
	},

    components: {
        Layout,
        PageHeader,
        // DropZone,
    },
};
</script>
<style scoped>

    #ExcelHover:hover {
        /* --vz-text-opacity: 1;
        color: rgba(var(--vz-success-rgb), var(--vz-text-opacity)) !important; */

        color: #878a99 !important;
    }

    #dropdownhover:hover {
        color: #878a99 !important;
    }
</style>
<template>

  <Layout>
    <PageHeader :title="title" :items="items" />
      <div class="row">
            <div class="col-lg-6">
                <div class="accordion accordion-border-box" id="genques-accordion">
                    <div class="accordion-item">
                        
                        <h2 class="accordion-header" id="genques-headingOne">
                            <button class="accordion-button" ref="clickingstep" type="button" data-bs-toggle="collapse" data-bs-target="#genques-collapseOne" aria-expanded="true" aria-controls="genques-collapseOne">
                                Step 1
                            </button>
                        </h2>
                        <div id="genques-collapseOne" class="accordion-collapse collapse show" aria-labelledby="genques-headingOne" data-bs-parent="#genques-accordion">
                            <div class="accordion-body">
                                <label for="firstNameinput" class="form-label">Choose Number Of Devices</label>
                    
                                <select @change="changeLocation($event)" class="form-select mb-3" aria-label="Default select example" disabled>
                                    <option value='no'> No of trade-in devices.</option>
                                    <option value="1">1-5 Devices </option>
                                    <option value="more" selected>6 - 1000 Devices</option>
                                    <option value="1000">1001 and above Devices</option>
                                </select>
                                <div>
                                    <hr>
                                    <span v-if="PhoneSupport != null">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <h4 class="card-title mb-0">Step 2</h4>
                                                <p>Please select Order</p>
                                            </div>
                                            <div class="col-lg-5">
                                                <center>
                                                        <router-link to="/order/titu">
                                                            <i class="bx bx-refresh text-success" role="button" id='ExcelHover' style="font-size:72px"></i> <br>
                                                        </router-link>
                                                        Trade in with upgrade device
                                                </center>
                                            </div>
                                            <div class="col-lg-2">
                                                <div class="d-flex align-items-center justify-content-center h-100">
                                                    <b class="h4">OR</b>
                                                </div>
                                                
                                            </div>
                                            <div class="col-lg-5">
                                                <center>
                                                    <router-link to="/order/newcreate">
                                                        <i class="bx bx-mobile text-success" id="dropdownhover" role="button" style="font-size:72px"></i> 
                                                    </router-link><br>
                                                    Trade In Only
                                                </center>
                                            </div>
                                        </div>
                                        <br>
                                        <span v-if='DiplayGrading'>
                                            <h4 class="card-title mb-0">Step 3</h4>

                                                <p>Download the <a :href="staticURLDownload+'storage/template/EnterpriseForm.xlsx'"> <b>template</b></a>, refer to the 
                                                <a :href="url_link" ><b>device list</b></a> and fill in the form based on the Grading guideline</p>
                                            <hr>  
                                            <h4 class="card-title mb-0">Step 4</h4>
                                            <span v-if="isPreviousUpload">
                                                <div class="alert alert-warning alert-borderless" role="alert">
                                                    You already submit excel file.    
                                                </div>
                                            </span>
                                            <span v-else>
                                                
                                                <span v-if="uploadYes">
                                            
                                                    <div v-if='deleteclick'>

                                                        <!-- <form enctype="multipart/form-data" v-on:submit.prevent="uploadFile()"> -->
                                                        <br>
                                                        <!-- <DropZone @drop.prevent="drop" @change="selectedFile"  :max-number-of-files='1'/> -->
                                                        <input class="form-control"  type="file" @change="uploadFile" ref="file">
                                                        <div class="d-grid gap-2">
                                                            <br>
                                                            
                                                            <button class="btn btn-secondary dary waves-effect waves-light" type="button" @click="submitFile"> Submit </button>
                                                        </div>
                                                        <!-- </form> -->                                            
                                                    </div>
                                                </span>
                                                <div v-if='messageBag'>
                                                    <br>
                                                    <div class="alert alert-danger alert-border-left alert-dismissible fade show" role="alert">
                                                        <i class="ri-alert-line me-3 align-middle fs-16"></i><strong>Error</strong>
                                                        {{ this.messageBag }}
                                                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                                    </div>
                                                    
                                                </div>
                                                <br>
                                            </span>
                                        </span>
                                    </span>
                                    <span v-else>
                                        <div class="alert alert-danger mb-xl-0" role="alert">
                                            <strong> This profile contain no country please update this profile </strong>
                                        </div>
                                    </span>
                                </div>

                                
                            </div>
                            <div v-if='LoadingUploadSeen'>
                                <br>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6" v-if='Imgseen'>
                <center>
                    <img v-bind:src="img_location" width="400" height="1200">
                </center>
            </div>
        </div>
        <br>
        <div v-if="isLoadingListDevices">
            <div class="spinner-border text-success" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        
        <div v-if='getUploadDevicesSeen'>
            <div class="row">
                <div class="col-lg-12">
                <div class="card">
                    <div class="card-header align-items-center d-flex">
                    <h4 class="card-title mb-0 flex-grow-1">List Of Devices</h4>
                    </div>

                    <div class="card-body">
                        <div class="live-preview">
                            <div class="row align-items-center g-12">
                                <div class="col-lg-12">

                                    <ul class="nav nav-tabs mb-3" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" data-bs-toggle="tab" href="#Summary" role="tab" aria-selected="false">
                                                Summary Order
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-bs-toggle="tab" href="#detailOrder" role="tab"
                                                aria-selected="false">
                                                Detail Order
                                            </a>
                                        </li>
                                    </ul>
                                    <div class="tab-content  text-muted">
                                        <div class="tab-pane active" id="Summary" role="tabpanel">
                                            <div class="table-responsive table-card">
                                                <table class="table align-middle table-nowrap mb-0">
                                                    <thead >
                                                        <tr>
                                                            <th scope="col">NO</th>
                                                            <th scope="col">MODEL</th>
                                                            <th scope="col">BRAND NAME</th>
                                                            <th scope="col">STORAGE</th>
                                                            <th scope="col"><center>GRADING</center></th>
                                                            <th scope="col">QUANTITY</th>
                                                            <th scope="col">UNIT PRICE</th>
                                                            <th scope="col">TOTAL AMOUNT</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in DevicesUpload" :key="index" class="content">
                                                            <td>{{ index+1 }}</td>
                                                            <td>{{ item.model }}</td>
                                                            <td>{{ item.brand }}</td>
                                                            <td>{{ item.storage }}</td>
                                                            <td><center>{{ item.name }}</center></td>
                                                            <td>{{ item.total }}</td>
                                                            <td>{{ DetailOrder.currency}} {{ item.price.toLocaleString('en-US') }}</td>
                                                            <td>{{ DetailOrder.currency}} {{ item.priceing.toLocaleString('en-US') }}</td>
                                                        </tr>
                                                        <tr v-if='isLoadingCalculateAllPrice'>
                                                            <td colspan="7">
                                                                <div class="spinner-border text-success" role="status">
                                                                    <span class="sr-only">Loading...</span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-else>

                                                            <td colspan="4"> </td>
                                                            <td> Total Quantity: </td>
                                                            <td> <b>{{ DetailOrder.quantity }}</b></td>
                                                            <td>
                                                                 Total Estimate:
                                                            </td>
                                                            <td><b>{{ DetailOrder.currency}} {{ totalPriceDevices.toLocaleString('en-US') }}</b></td>
                                                        </tr>
                                                        <tr v-if='messageBagTotalPrice == 0'>
                                                            <td colspan="4" > 
                                                                <div class="alert alert-danger alert-border-left alert-dismissible fade show" role="alert" v-if="ErrorUploadYes">
                                                                    <i class="ri-alert-line me-3 align-middle fs-16"></i><strong>Warning When Upload</strong> <br>
                                                                    Found {{ this.ErrorUpload.line }} line error when upload. <a href='#' data-bs-toggle="modal" data-bs-target=".bs-example-modal-sm">click to view</a>
                                                                    <!-- <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> -->
                                                                </div>

                                                                <div class="alert alert-danger alert-border-left alert-dismissible fade show" role="alert" v-if="DetailOrder.is_Expired">
                                                                    <i class="ri-alert-line me-3 align-middle fs-16"></i><strong>Order Expired</strong> <br>
                                                                    This order already expired due to exceed 14 days from the final quotation date.<br>
                                                                    Please click on clear button to create new order.
                                                                </div>
                                                            </td>
                                                            <td colspan="2" >
                                                            </td>
                                                            <td colspan="2" >
                                                                <div class="live-preview" v-if='ButtonSeen'>
                                                                    <!-- <p class="text-right">  -->
                                                                        <button class="btn btn-outline-info waves-effect waves-light" @click="reupload"> Clear Data </button> {{ " "}}{{ " "}}
                                                                        <!-- <button class="btn btn-outline-danger waves-effect waves-light" @click="rejectButton" type="button"> Reject </button> {{ " "}}{{ " "}} -->
                                                                        <span v-if="DetailOrder.is_Expired">
                                                                            
                                                                        </span>
                                                                        <span v-else>
                                                                            <button class="btn btn-outline-success waves-effect waves-light" @click="ApproveButton" type="button"> Accept </button>{{ " "}}{{ " "}}
                                                                        </span>
                                                                    <!-- </p> -->
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div class="tab-pane" id="detailOrder" role="tabpanel">
                    
                                            <table class="table align-middle table-nowrap mb-0">
                                                <thead >
                                                    <tr>
                                                        <th scope="col">NO.</th>
                                                        <th scope="col">MODEL</th>
                                                        <th scope="col">BRAND NAME</th>
                                                        <th scope="col">STORAGE</th>
                                                        <th scope="col">IMEI</th>
                                                        <th scope="col">GRADING</th>
                                                        <th scope="col">PRICE </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in DetailOrder.devices" :key="index" class="content">
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.model }}</td>
                                                        <td>{{ item.brand }}</td>
                                                        <td>{{ item.storage }}</td>
                                                        <td>{{ item.imei }}</td>
                                                        <td>{{ item.condition }}</td>
                                                        <td>{{ DetailOrder.currency}} {{ item.price }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="5"> </td>
                                                        <td>
                                                            Total Estimate:
                                                        </td>
                                                        <td>
                                                           <b> {{ DetailOrder.currency}} {{ DetailOrder.totalQuotation.toLocaleString('en-US') }}</b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- modal -->
        <div class="modal fade" id="exampleModalScrollable" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalScrollableTitle">
                            Quotaion Summary
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body">

                        <div v-if='openmodal'>
                            <p v-for="item in summary" :key="item.id" class="content">
                                {{ item.model }}
                            </p>
                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light"
                            data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary">Save changes</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade bs-example-modal-sm" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="mySmallModalLabel">View Error</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div class="modal-body" v-if="ErrorUploadYes">

                        <!-- <tr v-for="(item, index) in DevicesUpload" :key="index" class="content">
                            <td>{{ index+1 }}</td> -->
                        <div class="d-flex" v-for="(item, index) in ErrorUpload.msj_err" :key="index">
                            <div class="flex-shrink-0">
                                <i class="ri-error-warning-line text-warning"></i>
                            </div>
                            <div class="flex-grow-1 ms-2">
                                 
                                <p class="text-muted mb-0">{{ item.msj_err }} </p>
                            </div>
                        </div>


                    </div>
                    <div class="modal-footer">
                        <a href="javascript:void(0);" class="btn btn-link link-success fw-medium" data-bs-dismiss="modal"><i class="ri-close-line me-1 align-middle"></i> Close</a>
                    </div>
                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>

        <!-- end of modal -->
    </Layout>
</template>